import { render } from "./HelloWorld.vue?vue&type=template&id=70e3415f&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=70e3415f&scoped=true&lang=css"

import exportComponent from "/data/webcode/iotopenplattform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e3415f"]])

export default __exports__